<div [innerHtml]="navService.menu.companyStyle"></div>
<div class="row">
    <div class="display-initial fixed-top navbar navbar-fixed-top navbar-inverse pt-0">
        <div class="hidden-mobile-flex pimeo-blue py-2 row">
            <div class="navbar-header col-md-10" *ngIf="userService.isLoggedIn">
                <a class="btn navbar-btn link-white"
                   href="/#"
                   id="desktopMenu"
                   data-bs-toggle="dropdown"
                   aria-haspopup="true"
                   aria-expanded="false">
                    <fa-icon class="pull-left sm-pad-right"
                             [icon]="faUser"></fa-icon><span class="user-name">
                        {{
                            userService.user.fullName
                        }}
                    </span>
                </a>
                <ul class="dropdown-large dropdown-menu px-3 rounded-0"
                    aria-labelledby="desktopMenu">
                    <li class="border-0 cursor-pointer dropdown-item text-center">
                        <input type="button"
                               class="btn btn-primary full-width"
                               value="Switch Portal"
                               (click)="showCompanies()" />
                    </li>
                    <li class="border-0 cursor-pointer dropdown-item text-center">
                        <a [routerLink]="['/logout']" class="text-black">LOG OUT</a>
                    </li>
                    <li class="border-0 cursor-pointer dropdown-item text-center">
                        {{ userService.user.email }}
                    </li>
                    <li class="border-0 cursor-pointer dropdown-item text-center">
                        <a [routerLink]="['/privacy-policy']" class="text-black">Privacy Policy</a>
                    </li>
                </ul>
                <a
                    *ngFor="let menuItem of navService.menu.topMostMenuItems"
                    class="btn navbar-btn link-white no-border-width {{
                        navService.menu.linkState
                    }} {{ menuItem.classes }} {{
                        menuItem.isActive ? 'active-page' : ''
                    }}"
                    [routerLink]="menuItem.url">{{ menuItem.name }}
                </a>
            </div>
            <div class="navbar-header"
                 [ngClass]="{
                    'col-md-2': userService.isLoggedIn,
                    'col-md-1': !userService.isLoggedIn
                }">
                <a *ngIf="userService.isLoggedIn" class="navbar-brand pull-right me-0" [routerLink]="['/home']">PIMeo</a>
                <a *ngIf="!userService.isLoggedIn" class="navbar-brand pull-right me-0" [routerLink]="['/login']">PIMeo</a>
                <a
                    class="navbar-brand pull-right me-0"
                    target="_blank"
                    href="https://support.pimeo.net"
                    *ngIf="userService.isLoggedIn"
                    rel="noopener noreferrer">
                    <fa-icon [icon]="faQuestionCircle"></fa-icon>
                </a>
            </div>
        </div>
        <div class="pimeo-blue py-2 row hidden-desktop">
            <div class="dropdown hidden-desktop display-inline col-2 col-sm-1 pt-0"
                 *ngIf="userService.isLoggedIn">
                <a
                    class="btn btn-secondary dropdown-toggle custom-btn no-caret m-0"
                    href="/#"
                    id="mobileMenu"
                    data-bs-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false">
                    <fa-icon
                        style="font-size: 18pt"
                        [icon]="faBurgerMenu">
                    </fa-icon>
                </a>
                <div class="dropdown-large dropdown-menu rounded-0"
                     aria-labelledby="mobileMenu">
                    <div
                        *ngFor="let menuItem of getMobileMenuLeft()"
                         class="border-0 dropdown-item p-0">
                        <a
                            [routerLink]="[menuItem.url]"
                           >
                            {{ menuItem.name }}
                        </a>
                    </div>
                    <div class="dropdown-divider"></div>
                    <div class="border-0 dropdown-item p-0">
                        <input
                            type="button"
                            class="btn btn-primary full-width"
                            value="Switch Portal"
                            (click)="showCompanies()"
                        />
                    </div>
                    <div class="dropdown-divider"></div>
                    <div class="border-0 dropdown-item p-0">
                        <a [routerLink]="['/logout']" class="text-black">LOG OUT</a>
                    </div>
                    <div class="border-0 dropdown-item p-0">
                        <a (click)="stopPropogation($event)">
                            {{ userService.user.email }}
                        </a>
                    </div>
                    <div class="border-0 dropdown-item p-0">
                        <a [routerLink]="['/privacy-policy']" class="text-black">Privacy Policy</a>
                    </div>
                    <div class="dropdown-divider"></div>
                    <div class="border-0 dropdown-item p-0">
                        <a target="_blank"
                           href="https://support.pimeo.net"
                           rel="noopener noreferrer">
                            <fa-icon [icon]="faQuestionCircle"></fa-icon>
                            Help
                        </a>
                    </div>
                </div>
            </div>
            <div
                class="navbar-header hidden-desktop display-flex pt-0 align-items-center"
                [ngClass]="userService.isLoggedIn ? 'col-8 col-sm-10' : 'col-12'">
                <a *ngIf="userService.isLoggedIn" class="navbar-brand" [routerLink]="['/home']">PIMeo</a>
                <a *ngIf="!userService.isLoggedIn" class="navbar-brand" [routerLink]="['/login']">PIMeo</a>
            </div>
            <div
                class="dropdown hidden-desktop display-inline col-2 col-sm-1 dropleft pt-0"
                *ngIf="userService.isLoggedIn && (getMobileMenuRight() || []).length > 0"
            >
                <a class="btn btn-secondary dropdown-toggle custom-btn no-caret m-0"
                   href="/#"
                   id="mobileSectionMenu"
                   data-bs-toggle="dropdown"
                   aria-haspopup="true"
                   aria-expanded="false">
                    <fa-icon style="font-size: 18pt"
                             [icon]="faBurgerMenu"></fa-icon>
                </a>
                <div class="dropdown-large dropdown-menu rounded-0"
                    aria-labelledby="mobileMenu">
                    <div 
                        *ngFor="let menuItem of getMobileMenuRight(); let i = index"
                        class="border-0 dropdown-item p-0"
                        [ngClass]="{'active-page': menuItem.isActive}">
                        <ng-container
                            *ngIf="menuItem.subMenuItems.length; else clickableLink">
                            <span
                                class="nav-link"
                                (click)="toggleSubmenu(i); $event.stopPropagation()">
                                {{ menuItem.name }}
                                <fa-icon
                                    *ngIf="menuItem.subMenuItems && menuItem.subMenuItems.length"
                                    [icon]="menuItem.showSubmenu ? faChevronUp : faChevronDown"
                                    class="float-right"
                                    (click)="toggleSubmenu(i); $event.stopPropagation()">
                                </fa-icon>
                            </span>
                        </ng-container>
                        <ng-template #clickableLink>
                            <a
                                class="nav-link"
                                [routerLink]="[menuItem.url]">
                                {{ menuItem.name }}
                            </a>
                        </ng-template>
                        <ng-container 
                            *ngIf="menuItem.subMenuItems && menuItem.subMenuItems.length">
                            <div 
                                *ngIf="menuItem.showSubmenu" 
                                class="submenu">
                                <div 
                                    *ngFor="let subMenuItem of menuItem.subMenuItems" 
                                    class="border-0 dropdown-item p-0 pl-3">
                                    <a [routerLink]="[subMenuItem.url]">{{ subMenuItem.name }}</a>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <nav class="navbar navbar-pimeo hidden-mobile navbar-expand-sm full-width"
         *ngIf="userService.isLoggedIn">
        <ng-container *ngIf="navService.displayBreadcrumbs">
            <div class="col-11">
                <div class="navbar-header">
                    <a class="navbar-brand" [routerLink]="'/home'">
                        <img src="{{ navService.menu.companyLogo }}" />
                    </a>
                </div>
                <div class="collapse navbar-collapse">
                    <ul class="nav navbar-nav me-auto">
                        <li *ngFor="
                                let menuItem of navService.menu.mainMenuItems
                            "
                            class="nav-item dropdown {{ navService.menu.linkState }} {{
                                menuItem.classes
                            }} {{ menuItem.isActive ? 'active-page' : '' }}">
                            <ng-container
                                *ngIf="menuItem.subMenuItems.length; else clickableLink">
                                <span
                                    class="nav-link">
                                    {{ menuItem.name }}
                                </span>
                            </ng-container>
                            <ng-template #clickableLink>
                                <a
                                    class="nav-link"
                                    [routerLink]="[menuItem.url]">
                                    {{ menuItem.name }}
                                </a>
                            </ng-template>
                            <ul
                                *ngIf="menuItem.subMenuItems.length"
                                class="dropdown-menu">
                                <li
                                    *ngFor="let subMenuItem of menuItem.subMenuItems"
                                    class="nav-item">
                                    <a
                                        class="nav-link"
                                        [routerLink]="[subMenuItem.url]">
                                        {{ subMenuItem.name }}
                                    </a>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div>
            </div>
            <div
                class="col-1">
                <form
                    class="my-2 my-lg-0"
                    *ngIf="navService.menu.editLink != null">
                    <a
                        *ngIf="!navService.menu.isinEdit"
                        [routerLink]="[navService.menu.editLink.url]"
                       >
                        <fa-icon [icon]="faGear"></fa-icon>
                    </a>
                    <a
                        *ngIf="navService.menu.isinEdit"
                        [routerLink]="[navService.menu.editLink.url]"
                       >
                        <fa-icon [icon]="faLeftArrow"></fa-icon>
                    </a>
                </form>
            </div>
        </ng-container>
        <div
            class="full-width text-center"
            *ngIf="!navService.displayBreadcrumbs">
            <a
                [routerLink]="'/home'"
               >
                <img
                    class="navbar-brand-home"
                    src="{{ navService.menu.companyLogo }}"
                />
            </a>
        </div>
    </nav>
    <div class="col-12 full-width" *ngIf="userService.isLoggedIn">
        <h4 class="my-2 mx-0">{{ navService.menu.title }}</h4>
    </div>

    <client-switcher
        *ngIf="userService.isLoggedIn"
        #clientSwitcher
        (onSelect)="changeClient()">
    </client-switcher>
</div>
